const DECIMAL_LENGTH = 2;

export function padNumberWithZeros(number: number, length = DECIMAL_LENGTH) {
  return number.toString().padStart(length, '0');
}
